import {LoadingSpinnerPage, utils} from '@wallaby-ui/core';

import {PhRecommendationListLayout} from '../../components/PhRecommendationListLayout';
import {MerieDepartmentReportLayout} from '../../components/reports/MerieDepartmentReportLayout';
import {MerieHospitalNetworkReportLayout} from '../../components/reports/MerieHospitalNetworkReportLayout';
import {MerieHospitalReportLayout} from '../../components/reports/MerieHospitalReportLayout';
import {MerieUzisReportLayout} from '../../components/reports/merieuzisreport/MerieUzisReportLayout';
import {LIBRARY_NAME} from 'src/js/common/constants';
import {AntibiogramLayoutContainer} from 'src/js/components/antibiogram';
import {HaidiDashboardLayoutContainer} from 'src/js/components/dashboard/HaidiDashboardLayoutContainer';
import DocumentPropertiesTabPanel from 'src/js/components/DocumentPropertiesTabPanel';
import DocumentScreenTabPanel from 'src/js/components/DocumentScreenTabPanel';
import {EncounterDocumentLayout} from 'src/js/components/encounter/EncounterDocumentLayout';
import {EncounterLayout} from 'src/js/components/encounter/EncounterLayout';
import {EncounterSharedLayout} from 'src/js/components/encounter/EncounterSharedLayout';
import {HaiListLayoutContainer} from 'src/js/components/hai/HaiListLayoutContainer';
import {HospitalizationDetailLayoutContainer} from 'src/js/components/hospitalizations_detail/HospitalizationDetailLayoutContainer';
import {HospitalizationDetailLayoutV2} from 'src/js/components/hospitalizations_detail/HospitalizationDetailLayoutV2';
import {HospitalizedPatientsByHospSrcIdContainer} from 'src/js/components/HospitalizedPatientsByHospSrcIdContainer';
import {HospitalizedPatientsLayout} from 'src/js/components/HospitalizedPatientsLayout';
import {LabResultsListContainer} from 'src/js/components/lab_results_list';
import {NotFoundComponentBox} from 'src/js/components/NotFoundComponentBox';
import {PathogenDetailContainer} from 'src/js/components/pathogenDetail';
import {PatientLayout} from 'src/js/components/PatientLayout';
import {PatientListLayoutContainer} from 'src/js/components/PatientListLayoutContainer';
import {DepartmentReportLayoutContainer} from 'src/js/components/reports/DepartmentReportLayoutContainer';
import {HaiByPathogensReportLayoutContainer} from 'src/js/components/reports/HaiByPathogensReportLayout';
import {HaiYearlyOverviewReportLayoutContainer} from 'src/js/components/reports/HaiYearlyOverviewReportLayoutContainer';
import {HospitalNetworkReportLayoutContainer} from 'src/js/components/reports/HospitalNetworkReportLayoutContainer';
import {HospitalReportLayoutContainer} from 'src/js/components/reports/HospitalReportLayoutContainer';
// import ReportsAMRLayoutContainer from 'src/js/containers/layout/components/reports/ReportsAMRLayoutContainer';
// import ReportsLayoutContainer from 'src/js/containers/layout/components/reports/ReportsLayoutContainer';
// import RFReportsLayoutContainer from 'src/js/containers/layout/components/reports/RFReportsLayoutContainer';
import {SettingsLayoutContainer} from 'src/js/components/SettingsLayoutContainer';
import {UploadLayoutContainer} from 'src/js/components/UploadLayoutContainer';

const logger = utils.LogUtils.getLogger('LayoutComponentsDefinitions', LIBRARY_NAME);

const LAYOUT_COMPONENTS_DEFINITION = {
  HaidiDashboardLayoutContainer: {component: HaidiDashboardLayoutContainer},
  PatientListLayoutContainer: {component: PatientListLayoutContainer},
  HaiListLayoutContainer: {component: HaiListLayoutContainer},
  LoadingSpinnerPage: {component: LoadingSpinnerPage},
  NotFoundComponentBox: {component: NotFoundComponentBox},
  // reports
  HospitalReportLayoutContainer: {component: HospitalReportLayoutContainer},
  HospitalNetworkReportLayoutContainer: {component: HospitalNetworkReportLayoutContainer},
  DepartmentReportLayoutContainer: {component: DepartmentReportLayoutContainer},
  HaiByPathogensReportLayoutContainer: {component: HaiByPathogensReportLayoutContainer},
  HaiYearlyOverviewReportLayoutContainer: {component: HaiYearlyOverviewReportLayoutContainer},
  //
  AntibiogramLayoutContainer: {component: AntibiogramLayoutContainer},
  LabResultsListContainer: {component: LabResultsListContainer},
  PathogenDetailContainer: {component: PathogenDetailContainer},
  // TODO-JK: we are not using these components for now
  // ReportsLayoutContainer: {component: ReportsLayoutContainer},
  // RFReportsLayoutContainer: {component: RFReportsLayoutContainer},
  // ReportsAMRLayoutContainer: {component: ReportsAMRLayoutContainer},
  SettingsLayoutContainer: {component: SettingsLayoutContainer},
  UploadLayoutContainer: {component: UploadLayoutContainer},

  DocumentPropertiesTabPanel: {component: DocumentPropertiesTabPanel},
  DocumentScreenTabPanel: {component: DocumentScreenTabPanel},
  PatientLayout: {component: PatientLayout},
  EncounterSharedLayout: {
    component: EncounterSharedLayout,
  },
  EncounterLayout: {
    component: EncounterLayout,
  },
  EncounterDocumentLayout: {
    component: EncounterDocumentLayout,
  },

  HospitalizedPatientsByHospSrcIdContainer: {
    component: HospitalizedPatientsByHospSrcIdContainer,
  },
  HospitalizedPatientsLayout: {
    component: HospitalizedPatientsLayout,
  },
  MerieHospitalNetworkReportLayout: {
    component: MerieHospitalNetworkReportLayout,
  },
  MerieHospitalReportLayout: {
    component: MerieHospitalReportLayout,
  },
  MerieDepartmentReportLayout: {
    component: MerieDepartmentReportLayout,
  },
  MerieUzisReportLayout: {
    component: MerieUzisReportLayout,
  },
  HospitalizationDetailLayoutContainer: {
    component: HospitalizationDetailLayoutContainer,
  },
  HospitalizationDetailLayoutV2: {
    component: HospitalizationDetailLayoutV2,
  },
  PhRecommendationListLayout: {
    component: PhRecommendationListLayout,
  },
};

export class DynamicLayoutComponent {
  static getComponentClass(componentName) {
    let result;
    if (LAYOUT_COMPONENTS_DEFINITION[componentName]) {
      result = LAYOUT_COMPONENTS_DEFINITION[componentName].component;
    } else {
      logger.warn(`Unrecognized layout component for DynamicLayoutComponent: ${componentName}`);
      result = undefined;
    }
    return result;
  }

  static getComponentDefinition(componentName) {
    return LAYOUT_COMPONENTS_DEFINITION[componentName];
  }
}

export default DynamicLayoutComponent;
